<script setup lang="ts">

const platform = useState('platform')

if (platform.value.settings.missionSearchPage?.customPage) {
  await navigateTo(platform.value.settings.missionSearchPage?.customPage, {external: true})
}

</script>

<template>
  <div class="w-full min-h-[calc(100vh-var(--ui-header-height))] bg-muted">
    <MissionSearchPage />
  </div>
</template>